import { Component, OnInit } from '@angular/core';
import { WizardType, RegistrationStepQuery, AuthService } from '@fgb/core';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'fgb-registration-success-page',
  templateUrl: './registration-success-page.component.html',
  styleUrls: ['./registration-success-page.component.scss'],
})
export class RegistrationSuccessPageComponent implements OnInit {
  wizardType?: WizardType;
  wizardTypes = WizardType;
  url: string;

  constructor(private registrationStepQuery: RegistrationStepQuery, private authService: AuthService) {}

  ngOnInit() {
    this.wizardType = this.registrationStepQuery.getWizardType();
  }

  loginAndRedirect() {
    firstValueFrom(this.authService.refreshAccessToken()).then((data) => {
      this.authService.loginUsingToken(data.AccessToken, data.RefreshToken, '/');
    });
  }
}
